import React from "react";
import styled from "styled-components";
import { CompanyLogo } from "../../components/tables/CompanyLogo";
import { Avatar } from "../../components/visuals/Avatar";
import {
  ElementContainer,
  FlexibleContainer,
  VerticalLine,
} from "../../components/containers/styledComponents";
import { CompassParagraph } from "../../components/common/styledComponents";
import { greyText, lightGreys } from "../../styles";
import { formatReadable } from "../../utils/formattingUtils";
import { EngagementType } from "../../models/stewardshipModels";
import environmental from "../../assets/svg/environmental_circle.svg";
import social from "../../assets/svg/social_circle.svg";
import governance from "../../assets/svg/governance_circle.svg";
import strategy from "../../assets/svg/strategy_circle.svg";

const META_THEME_ICONS: Record<EngagementType, string> = {
  [EngagementType.Environmental]: environmental,
  [EngagementType.Social]: social,
  [EngagementType.Governance]: governance,
  [EngagementType.StrategyRiskCommunication]: strategy,
};

const HeaderContainer = styled(ElementContainer)`
  padding: 14px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.04);
`;

export const EngagementStatusHeader = ({
  companyName,
  companyLogoUrl,
  companyId,
  managerName,
  managerImage,
  metaTheme,
  theme,
  subTheme,
}: EngagementStatusHeaderProps): JSX.Element => {
  const formattedCompanyName = formatReadable(companyName);

  return (
    <HeaderContainer ai="center">
      <FlexibleContainer ml="14px">
        <CompanyLogo
          key={formattedCompanyName}
          companyId={companyId}
          name={formattedCompanyName}
          logoUrl={companyLogoUrl}
          size="lg"
        />
      </FlexibleContainer>
      <VerticalLine color={lightGreys.borderLightGrey} />
      <FlexibleContainer ml="12px" mr="12px" ai="center">
        <Avatar
          username={managerName}
          image={managerImage}
          displayText={managerName}
          size="default"
          tooltip
        />
      </FlexibleContainer>
      <VerticalLine color={lightGreys.borderLightGrey} />
      <FlexibleContainer ml="12px" mr="12px" ai="center">
        <Avatar
          username={metaTheme}
          image={META_THEME_ICONS[metaTheme] || strategy}
          size="default"
          tooltip
        />
        <ElementContainer flexDirection="column">
          <CompassParagraph fontSize={13}>
            {formatReadable(theme)}
          </CompassParagraph>
          <CompassParagraph fontSize={11} color={greyText}>
            {formatReadable(subTheme)}
          </CompassParagraph>
        </ElementContainer>
      </FlexibleContainer>
    </HeaderContainer>
  );
};

export interface EngagementStatusHeaderProps {
  companyName: string;
  companyLogoUrl: string;
  companyId: string;
  managerName: string;
  managerImage: string | null;
  metaTheme: EngagementType;
  theme: string;
  subTheme: string;
}
